import React from 'react'

import Typography from '../../UniformComponents/Typography'

import './SaveStatusPill.scss'

const STATUS_ICON = {
    saving: 'fa-loader fa-spin',
    pending: 'fa-clock',
    saved: 'fa-circle-check',
}

const SaveStatusPill = ({ status = 'saved', label }) => {
    const icon = STATUS_ICON[status] ?? STATUS_ICON.saved

    return (
        <div className={`pp-save-status-pill pp-save-status-pill--${status}`}>
            <i className={`far ${icon}`} />
            <Typography type="tiny">{label}</Typography>
        </div>
    )
}

export default SaveStatusPill
